import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import Fetch from '../functions/Fetch';
import { useSelector } from 'react-redux';

function List() {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallprocesses'
  }

  let list = {
    labelTitle: 'Lista de Processos',
    labelTitleButtonAdd: 'Incluir novo Processo',
    fieldsShowOnDelete: ['process_number'],
    icon: 'fa-clipboard-check',
    filter: {
      friendly_url: friendly_url
    },
    columns: [
      {
        name: 'process_number',
        label: 'Número',
        width: '12%'
      },
      {
        name: 'project_name',
        label: 'Projeto'
      },
      {
        name: 'opening_date',
        label: 'Data de Abertura',
        width: '10%'
      },
      {
        name: 'process_type',
        label: 'Tipo',
        width: '10%'
      },
      {
        name: 'object',
        label: 'Objeto'
      }
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        canAdd={false}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
        icon={list.icon}
      />
    </div>
  );
}
export default List;
